// Atualização do app desktop (feature atualizacao): plugin oficial do Tauri. Ele baixa o
// latest.json do repositório público de versões, confere a assinatura com a chave pública
// do tauri.conf.json e recusa arquivos sem a assinatura certa (AC-204).
// Na web não existe atualizador: recarregar a página já traz a versão nova (AC-206).
import { isTauri } from './desktop';

export interface AvailableUpdate {
  version: string;
  /** novidades escritas na publicação da versão */
  notes: string | null;
  /** baixa e instala; `onProgress` recebe 0–100 (ou null quando o tamanho é desconhecido) */
  install(onProgress: (percent: number | null) => void): Promise<void>;
}

export interface UpdaterBridge {
  check(): Promise<AvailableUpdate | null>;
  relaunch(): Promise<void>;
}

export async function getUpdater(): Promise<UpdaterBridge | null> {
  if (!isTauri()) return null;
  const updater = await import('@tauri-apps/plugin-updater');
  const proc = await import('@tauri-apps/plugin-process');
  return {
    async check() {
      const update = await updater.check();
      if (!update) return null;
      return {
        version: update.version,
        notes: update.body?.trim() || null,
        async install(onProgress) {
          let total = 0;
          let done = 0;
          await update.downloadAndInstall((event) => {
            if (event.event === 'Started') {
              total = event.data.contentLength ?? 0;
              onProgress(total ? 0 : null);
            } else if (event.event === 'Progress') {
              done += event.data.chunkLength;
              onProgress(total ? Math.min(100, Math.round((done / total) * 100)) : null);
            } else if (event.event === 'Finished') {
              onProgress(100);
            }
          });
        },
      };
    },
    relaunch: () => proc.relaunch(),
  };
}
